import React, { Component   } from 'react';
import * as auth0 from 'auth0-js';
import axios from 'axios';  
import * as constantes from '../../constantes';

const history = require("history").createBrowserHistory()

class Auth extends Component {

  constructor(props) {
    super(props);

      this.auth0 = new auth0.WebAuth({    
        clientID: 'HxjmxbKtCcm2os0Pyfo7QYmA7J5kWDeC',
        domain: 'tcperu.auth0.com',
        responseType: 'token id_token', 
        redirectUri: constantes.AUTH_API, 
        scope: 'openid profile read:auth read:expert',
        audience: 'https://appweb.sedetc.gob.pe'
      });
    
    this.getProfile = this.getProfile.bind(this);
    this.getUser = this.getUser.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.autenticacion = this.autenticacion.bind(this);
    this.isLoading = this.isLoading.bind(this);
    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);

    this.closeSession = this.closeSession.bind(this);
    
  }

  getProfile() {
    return this.profile;
  }

  getIdToken() {
    return this.idToken;
  }

  getUser() {
    return this.user;
  }

  isLoading() {
    return false;
  }

  isAuthenticated() {
    return new Date().getTime() > localStorage.getItem('expires_at')
  }

  isExpired(){ 
    let isAuthenticated = this.isAuthenticated();
    if( isAuthenticated ){
        auth0Client.closeSession(); 
    }
    return false;
}

  signIn() {
    this.auth0.authorize();
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (err){
          return reject(err);
        }
        if (!authResult || !authResult.accessToken) {
          return reject(err);
        }
        resolve('acceso');
        this.autenticacion(authResult);
      });
    })

  }

  autenticacion(authResult){
    console.log('autenticacion - INI'  );

    this.idToken = authResult.accessToken;
    this.profile = authResult.idTokenPayload;
    this.user = authResult.idTokenPayload.nickname
    this.expiresAt = authResult.expiresIn * 1000 + new Date().getTime();
    localStorage.setItem('AccessToken', this.idToken)
    localStorage.setItem('expires_at', this.expiresAt)
    localStorage.setItem('usuario', this.user)

    let usuario = this.user ;
    let url = 'https://tomcat.sedetc.gob.pe/autentica-services-0.0.1/operaciones/app2/EXPERT/'+ usuario ;
    console.log('url - ' , url );

    axios.get( url , {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('AccessToken')
            }
    }).then((response) => {
        console.log('autenticacion - respuesta obtenida' );

        let operaciones = response.data;
        if(operaciones !== ''){

          console.log('usuario - ' , usuario ); 
          console.log('operaciones - ' , response.data );

          localStorage.setItem('operaciones', JSON.stringify(operaciones))
          window.location.href = '/inicio';
          
        }else{
          this.signOut();
          window.location.href = '/';
        }
      }, (error) => {
          console.error('autenticacion - error = ' , error);
      }
    );

  }

  signOut() {
    console.log('signOut()');
    this.idToken = null;
    this.profile = null;
    this.user = null;
    this.expiresAt = null;
    localStorage.removeItem('AccessToken')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('usuario')
    localStorage.removeItem('operaciones')
  }

  closeSession(){
    this.signOut();
    window.location.href = '/';
  }

}

const auth0Client = new Auth();

export default auth0Client;